import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-long-down-left', 'ArrowLongDownLeft', [["path",{"d":"M11 19H5m0 0v-6m0 6L19 5","key":"svg-0"}]]);